<template lang="pug">
  div
    v-btn(raised small icon color="app-append" @click="openDialog" class="ma-0")
      v-icon.white--text add

    v-dialog(lazy persistent v-model="dialog" max-width=440)
      v-card(v-if="one !== null")
        v-card-title.app-append
          span.white--text {{$t('append')}}
          v-spacer
          v-btn.ma-0(flat small icon color="white" @click="dialog = false")
            v-icon(size=18) close

        v-card-text
          v-text-field(
            type="text"
            :label="$t('code')"
            v-model="one.code"
            autocapitalize="off"
            ref="code"
            :rules="[rules.required]"
            validate-on-blur
            autofocus
            )

          v-text-field(
            type="text"
            :label="$t('name')"
            v-model="one.name"
            autocapitalize="off"
            ref="name"
            :rules="[rules.required]"
            validate-on-blur)

          div(
            v-for="customer, cuIndex in one.customers"
            :key="cuIndex"
          )
            v-text-field(
              type="text"
              label="担当者名"
              v-model="customer.name"
              ref="customer_name"
              :rules="[rules.required]"
              autocapitalize="off"
              )

          span.remarks 登録後、更新画面から担当者を追加できます。

        v-card-actions
          v-spacer
          v-btn(
            flat
            color="app-append"
            @click.stop="save")
            span {{$t('save')}}
</template>

<script>
import rules from '@/common/mixins/rules'

export default {
  data () {
    return {
      dialog: false,
      one: null
    }
  },
  mixins: [rules],
  watch: {
    dialog (val) {
      if (!val) {
        this.one = null
      }
    }
  },
  methods: {
    openDialog () {
      this.one = {
        id: null,
        code: null,
        name: null,
        customers: [
          {
            id: null,
            name: 'ご担当者'
          }
        ]
      }
      this.resetRuleError()
      this.dialog = true
    },
    save () {
      let self = this
      if (self.hasRuleError()) {
        self.$toastr.warning(self.$t('_rules.invalidate_message'))
        return true
      }
      self.$ajax
        .post('/companies/index', self.one)
        .then(function (response) {
          self.dialog = false
          self.$emit('complete', response.data.company)
        })
        .catch(function (error) {
          console.dir(error)
          self.$toastr.error(
            self.$t(error.response.data.translate_code) ||
              error.response.data.message
          )
        })
    }
  }
}
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/pages/Customer/Append.vue